export const LEGAL_REPRESENTATIVE_REQUIRED_FIELDS = [
  'label',
  'name',
  'rut',
  'nationality',
  'profession',
  'email',
  'civilStatus',
];

export const EMPTY_LEGAL_REPRESENTATIVE_DEFAULTS = {
  label: 'SR',
  name: '',
  rut: '',
  nationality: 'chileno',
  profession: '',
  email: '',
  civilStatus: 'single',
  mainDisabled: false,
  selected: true,
};

export const createEmptyLegalRepresentative = () => ({
  id: Date.now(),
  ...EMPTY_LEGAL_REPRESENTATIVE_DEFAULTS,
});

export const isLegalRepresentativeComplete = (representative) => (
  LEGAL_REPRESENTATIVE_REQUIRED_FIELDS.every(
    (field) => String(representative?.[field] ?? '').trim() !== '',
  )
);
